angular.module('rjmNg.constants')
.constant('dependencyEnums',
  RESOURCE_DEPENDENCIES: Object.freeze
    charts: 'Charts'
    columns: 'Columns'
    figures: 'Reports'
    email_summaries: 'Email Summaries'
    graphical_email_summaries: 'Graphical Email Summaries'
    users: 'Users'
    metrics: 'Metrics'
    dashboard_items: 'Dashboards'

  RESOURCE_TYPES: Object.freeze
    METRIC: 'Metric'
    DIMENSION: 'Dimension'
    FILTER_SET: 'Filter Set'
    FIGURE: 'Report'
)
